import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../../services/auth.service';

// Si no estamos autenticados redirige al login
export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getAccessToken();

  if (token && !authService.isTokenExpired(token)) {
    return true;
  } else if (token) {
    return authService.refreshAccessToken().pipe(
      map(() => true),
      catchError(() => of(router.createUrlTree(['/login'])))
    );
  } else {
    return router.createUrlTree(['/login']);
  }
};
